const SKELETON_HEIGHT = 361;

export {SKELETON_HEIGHT};
